
  // Auto-generated iconPathMapping. Do not edit directly.
  // To regenerate, run: yarn generate-icons

  import * as Assets from '../../assets/index';
  import { IconSize, IconVariant, IconVariantMapping } from './Icon.types';
  import { IconType } from './IconTypes.enum';

  export const iconPathMapping: { [key in IconType]: IconVariantMapping } = {
      [IconType.Ach]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Ach16,
      [IconSize.Medium]: Assets.Ach24
    }
  },
  [IconType.AddFile]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AddFile16,
      [IconSize.Medium]: Assets.AddFile24
    }
  },
  [IconType.Address]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Address16,
      [IconSize.Medium]: Assets.Address24
    }
  },
  [IconType.ADP]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ADP16,
      [IconSize.Medium]: Assets.ADP24
    }
  },
  [IconType.Agent]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Agent16,
      [IconSize.Medium]: Assets.Agent24
    }
  },
  [IconType.AgentSuggestion]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AgentSuggestion16,
      [IconSize.Medium]: Assets.AgentSuggestion24
    }
  },
  [IconType.AiAgentDot]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AiAgentDot16,
      [IconSize.Medium]: Assets.AiAgentDot24
    }
  },
  [IconType.AiAgentIndicator]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AiAgentIndicator16,
      [IconSize.Medium]: Assets.AiAgentIndicator24
    }
  },
  [IconType.AiAgentTopbar]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AiAgentTopbar16,
      [IconSize.Medium]: Assets.AiAgentTopbar24
    }
  },
  [IconType.AiSparkle]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AiSparkle16,
      [IconSize.Medium]: Assets.AiSparkle24
    }
  },
  [IconType.AllPayments]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AllPayments16,
      [IconSize.Medium]: Assets.AllPayments24
    }
  },
  [IconType.AllTasks]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.AllTasks16,
      [IconSize.Medium]: Assets.AllTasks24
    }
  },
  [IconType.Amex]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Amex16,
      [IconSize.Medium]: Assets.Amex24
    }
  },
  [IconType.Amount]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Amount16,
      [IconSize.Medium]: Assets.Amount24
    }
  },
  [IconType.Analyst]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Analyst16,
      [IconSize.Medium]: Assets.Analyst24
    }
  },
  [IconType.Api]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Api16,
      [IconSize.Medium]: Assets.Api24
    }
  },
  [IconType.Apple]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Apple16,
      [IconSize.Medium]: Assets.Apple24
    }
  },
  [IconType.Approve]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Approve16,
      [IconSize.Medium]: Assets.Approve24
    }
  },
  [IconType.Approved]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Approved16,
      [IconSize.Medium]: Assets.Approved24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Approved16Solid,
      [IconSize.Medium]: Assets.Approved24Solid
    }
  },
  [IconType.ArrowDown]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ArrowDown16,
      [IconSize.Medium]: Assets.ArrowDown24
    }
  },
  [IconType.ArrowLeft]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ArrowLeft16,
      [IconSize.Medium]: Assets.ArrowLeft24
    }
  },
  [IconType.ArrowRight]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ArrowRight16,
      [IconSize.Medium]: Assets.ArrowRight24
    }
  },
  [IconType.ArrowUp]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ArrowUp16,
      [IconSize.Medium]: Assets.ArrowUp24
    }
  },
  [IconType.Avatar]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Avatar16,
      [IconSize.Medium]: Assets.Avatar24
    }
  },
  [IconType.Bank]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Bank16,
      [IconSize.Medium]: Assets.Bank24
    }
  },
  [IconType.Bill]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Bill16,
      [IconSize.Medium]: Assets.Bill24
    }
  },
  [IconType.Built]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Built16,
      [IconSize.Medium]: Assets.Built24
    }
  },
  [IconType.BusinessDirectory]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.BusinessDirectory16,
      [IconSize.Medium]: Assets.BusinessDirectory24
    }
  },
  [IconType.BusinessLocation]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.BusinessLocation16,
      [IconSize.Medium]: Assets.BusinessLocation24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.BusinessLocation16Solid,
      [IconSize.Medium]: Assets.BusinessLocation24Solid
    }
  },
  [IconType.BusinessName]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.BusinessName16,
      [IconSize.Medium]: Assets.BusinessName24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.BusinessName16Solid,
      [IconSize.Medium]: Assets.BusinessName24Solid
    }
  },
  [IconType.BusinessNumber]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.BusinessNumber16,
      [IconSize.Medium]: Assets.BusinessNumber24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.BusinessNumber16Solid,
      [IconSize.Medium]: Assets.BusinessNumber24Solid
    }
  },
  [IconType.BusinessType]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.BusinessType16,
      [IconSize.Medium]: Assets.BusinessType24
    }
  },
  [IconType.Calendar]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Calendar16,
      [IconSize.Medium]: Assets.Calendar24
    }
  },
  [IconType.CapitalOne]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.CapitalOne16,
      [IconSize.Medium]: Assets.CapitalOne24
    }
  },
  [IconType.Card]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Card16,
      [IconSize.Medium]: Assets.Card24
    }
  },
  [IconType.CardSimilarDataApproved]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.CardSimilarDataApproved16,
      [IconSize.Medium]: Assets.CardSimilarDataApproved24
    }
  },
  [IconType.Chargebacks]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Chargebacks16,
      [IconSize.Medium]: Assets.Chargebacks24
    }
  },
  [IconType.Chat]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Chat16,
      [IconSize.Medium]: Assets.Chat24
    }
  },
  [IconType.ChatNotification]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChatNotification16,
      [IconSize.Medium]: Assets.ChatNotification24
    }
  },
  [IconType.ChatNotificationHuge]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChatNotificationHuge16,
      [IconSize.Medium]: Assets.ChatNotificationHuge24
    }
  },
  [IconType.Check]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Check16,
      [IconSize.Medium]: Assets.Check24
    }
  },
  [IconType.ChevronDown]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChevronDown16,
      [IconSize.Medium]: Assets.ChevronDown24
    }
  },
  [IconType.ChevronLeft]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChevronLeft16,
      [IconSize.Medium]: Assets.ChevronLeft24
    }
  },
  [IconType.ChevronLeftEnd]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChevronLeftEnd16,
      [IconSize.Medium]: Assets.ChevronLeftEnd24
    }
  },
  [IconType.ChevronRight]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChevronRight16,
      [IconSize.Medium]: Assets.ChevronRight24
    }
  },
  [IconType.ChevronRightEnd]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChevronRightEnd16,
      [IconSize.Medium]: Assets.ChevronRightEnd24
    }
  },
  [IconType.ChevronUp]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ChevronUp16,
      [IconSize.Medium]: Assets.ChevronUp24
    }
  },
  [IconType.Close]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Close16,
      [IconSize.Medium]: Assets.Close24
    }
  },
  [IconType.Clover]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Clover16,
      [IconSize.Medium]: Assets.Clover24
    }
  },
  [IconType.Collapse]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Collapse16,
      [IconSize.Medium]: Assets.Collapse24
    }
  },
  [IconType.Company]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Company16,
      [IconSize.Medium]: Assets.Company24
    }
  },
  [IconType.ComplyAdvantage]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ComplyAdvantage16,
      [IconSize.Medium]: Assets.ComplyAdvantage24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.ComplyAdvantage16Solid,
      [IconSize.Medium]: Assets.ComplyAdvantage24Solid
    }
  },
  [IconType.ContactBusinessLocation]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ContactBusinessLocation16,
      [IconSize.Medium]: Assets.ContactBusinessLocation24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.ContactBusinessLocation16Solid,
      [IconSize.Medium]: Assets.ContactBusinessLocation24Solid
    }
  },
  [IconType.ContactDetails]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ContactDetails16,
      [IconSize.Medium]: Assets.ContactDetails24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.ContactDetails16Solid,
      [IconSize.Medium]: Assets.ContactDetails24Solid
    }
  },
  [IconType.ContactNumber]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ContactNumber16,
      [IconSize.Medium]: Assets.ContactNumber24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.ContactNumber16Solid,
      [IconSize.Medium]: Assets.ContactNumber24Solid
    }
  },
  [IconType.Copy]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Copy16,
      [IconSize.Medium]: Assets.Copy24
    }
  },
  [IconType.CreditDirection]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.CreditDirection16,
      [IconSize.Medium]: Assets.CreditDirection24
    }
  },
  [IconType.CryptoService]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.CryptoService16,
      [IconSize.Medium]: Assets.CryptoService24
    }
  },
  [IconType.Debit]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Debit16,
      [IconSize.Medium]: Assets.Debit24
    }
  },
  [IconType.DebitDirection]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.DebitDirection16,
      [IconSize.Medium]: Assets.DebitDirection24
    }
  },
  [IconType.Declined]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Declined16,
      [IconSize.Medium]: Assets.Declined24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Declined16Solid,
      [IconSize.Medium]: Assets.Declined24Solid
    }
  },
  [IconType.Description]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Description16,
      [IconSize.Medium]: Assets.Description24
    }
  },
  [IconType.Desktop]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Desktop16,
      [IconSize.Medium]: Assets.Desktop24
    }
  },
  [IconType.DMLinking]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.DMLinking16,
      [IconSize.Medium]: Assets.DMLinking24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.DMLinking16Solid,
      [IconSize.Medium]: Assets.DMLinking24Solid
    }
  },
  [IconType.DMMoneyReceive]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.DMMoneyReceive16,
      [IconSize.Medium]: Assets.DMMoneyReceive24
    }
  },
  [IconType.DuckduckGo]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.DuckduckGo16,
      [IconSize.Medium]: Assets.DuckduckGo24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.DuckduckGo16Solid,
      [IconSize.Medium]: Assets.DuckduckGo24Solid
    }
  },
  [IconType.Edit]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Edit16,
      [IconSize.Medium]: Assets.Edit24
    }
  },
  [IconType.EditorDashboard]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.EditorDashboard16,
      [IconSize.Medium]: Assets.EditorDashboard24
    }
  },
  [IconType.EditorExternal]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.EditorExternal16,
      [IconSize.Medium]: Assets.EditorExternal24
    }
  },
  [IconType.Ekata]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Ekata16,
      [IconSize.Medium]: Assets.Ekata24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Ekata16Solid,
      [IconSize.Medium]: Assets.Ekata24Solid
    }
  },
  [IconType.Email]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Email16,
      [IconSize.Medium]: Assets.Email24
    }
  },
  [IconType.Enrichment]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Enrichment16,
      [IconSize.Medium]: Assets.Enrichment24
    }
  },
  [IconType.Enrolled]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Enrolled16,
      [IconSize.Medium]: Assets.Enrolled24
    }
  },
  [IconType.EnrollmentStatus]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.EnrollmentStatus16,
      [IconSize.Medium]: Assets.EnrollmentStatus24
    }
  },
  [IconType.Evolve]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Evolve16,
      [IconSize.Medium]: Assets.Evolve24
    }
  },
  [IconType.Expand]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Expand16,
      [IconSize.Medium]: Assets.Expand24
    }
  },
  [IconType.Expense]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Expense16,
      [IconSize.Medium]: Assets.Expense24
    }
  },
  [IconType.ExternalLink]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ExternalLink16,
      [IconSize.Medium]: Assets.ExternalLink24
    }
  },
  [IconType.Facebook]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Facebook16,
      [IconSize.Medium]: Assets.Facebook24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Facebook16Solid,
      [IconSize.Medium]: Assets.Facebook24Solid
    }
  },
  [IconType.FileReport]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.FileReport16,
      [IconSize.Medium]: Assets.FileReport24
    }
  },
  [IconType.Filter]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Filter16,
      [IconSize.Medium]: Assets.Filter24
    }
  },
  [IconType.FilterActive]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.FilterActive16,
      [IconSize.Medium]: Assets.FilterActive24
    }
  },
  [IconType.Financing]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Financing16,
      [IconSize.Medium]: Assets.Financing24
    }
  },
  [IconType.Fiserv]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Fiserv16,
      [IconSize.Medium]: Assets.Fiserv24
    }
  },
  [IconType.FlexCard]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.FlexCard16,
      [IconSize.Medium]: Assets.FlexCard24
    }
  },
  [IconType.FlowBuilder]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.FlowBuilder16,
      [IconSize.Medium]: Assets.FlowBuilder24
    }
  },
  [IconType.FlowMonitoring]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.FlowMonitoring16,
      [IconSize.Medium]: Assets.FlowMonitoring24
    }
  },
  [IconType.Forest]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Forest16,
      [IconSize.Medium]: Assets.Forest24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Forest16Solid,
      [IconSize.Medium]: Assets.Forest24Solid
    }
  },
  [IconType.Freebies]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Freebies16,
      [IconSize.Medium]: Assets.Freebies24
    }
  },
  [IconType.Frr]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Frr16,
      [IconSize.Medium]: Assets.Frr24
    }
  },
  [IconType.FsPyUsd]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.FsPyUsd16,
      [IconSize.Medium]: Assets.FsPyUsd24
    }
  },
  [IconType.Gain]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Gain16,
      [IconSize.Medium]: Assets.Gain24
    }
  },
  [IconType.GBG]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.GBG16,
      [IconSize.Medium]: Assets.GBG24
    }
  },
  [IconType.Github]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Github16,
      [IconSize.Medium]: Assets.Github24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Github16Solid,
      [IconSize.Medium]: Assets.Github24Solid
    }
  },
  [IconType.GoodsReceived]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.GoodsReceived16,
      [IconSize.Medium]: Assets.GoodsReceived24
    }
  },
  [IconType.Google]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Google16,
      [IconSize.Medium]: Assets.Google24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Google16Solid,
      [IconSize.Medium]: Assets.Google24Solid
    }
  },
  [IconType.Gusto]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Gusto16,
      [IconSize.Medium]: Assets.Gusto24
    }
  },
  [IconType.HasPreviouslyApprovedPayments]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.HasPreviouslyApprovedPayments16,
      [IconSize.Medium]: Assets.HasPreviouslyApprovedPayments24
    }
  },
  [IconType.HasProhibited]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.HasProhibited16,
      [IconSize.Medium]: Assets.HasProhibited24
    }
  },
  [IconType.HasSanctioned]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.HasSanctioned16,
      [IconSize.Medium]: Assets.HasSanctioned24
    }
  },
  [IconType.Help]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Help16,
      [IconSize.Medium]: Assets.Help24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Help16Solid,
      [IconSize.Medium]: Assets.Help24Solid
    }
  },
  [IconType.Hide]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Hide16,
      [IconSize.Medium]: Assets.Hide24
    }
  },
  [IconType.HighAmount]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.HighAmount16,
      [IconSize.Medium]: Assets.HighAmount24
    }
  },
  [IconType.Idm]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Idm16,
      [IconSize.Medium]: Assets.Idm24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Idm16Solid,
      [IconSize.Medium]: Assets.Idm24Solid
    }
  },
  [IconType.Industry]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Industry16,
      [IconSize.Medium]: Assets.Industry24
    }
  },
  [IconType.Information]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Information16,
      [IconSize.Medium]: Assets.Information24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Information16Solid,
      [IconSize.Medium]: Assets.Information24Solid
    }
  },
  [IconType.Inspect]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Inspect16,
      [IconSize.Medium]: Assets.Inspect24
    }
  },
  [IconType.International]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.International16,
      [IconSize.Medium]: Assets.International24
    }
  },
  [IconType.Invoice]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Invoice16,
      [IconSize.Medium]: Assets.Invoice24
    }
  },
  [IconType.JPM]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.JPM16,
      [IconSize.Medium]: Assets.JPM24
    }
  },
  [IconType.LegalCompanyAddress]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.LegalCompanyAddress16,
      [IconSize.Medium]: Assets.LegalCompanyAddress24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.LegalCompanyAddress16Solid,
      [IconSize.Medium]: Assets.LegalCompanyAddress24Solid
    }
  },
  [IconType.LegalCompanyName]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.LegalCompanyName16,
      [IconSize.Medium]: Assets.LegalCompanyName24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.LegalCompanyName16Solid,
      [IconSize.Medium]: Assets.LegalCompanyName24Solid
    }
  },
  [IconType.Link]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Link16,
      [IconSize.Medium]: Assets.Link24
    }
  },
  [IconType.Linkedln]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Linkedln16,
      [IconSize.Medium]: Assets.Linkedln24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Linkedln16Solid,
      [IconSize.Medium]: Assets.Linkedln24Solid
    }
  },
  [IconType.Linking]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Linking16,
      [IconSize.Medium]: Assets.Linking24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Linking16Solid,
      [IconSize.Medium]: Assets.Linking24Solid
    }
  },
  [IconType.Location]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Location16,
      [IconSize.Medium]: Assets.Location24
    }
  },
  [IconType.Lock]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Lock16,
      [IconSize.Medium]: Assets.Lock24
    }
  },
  [IconType.LogIn]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.LogIn16,
      [IconSize.Medium]: Assets.LogIn24
    }
  },
  [IconType.LogOut]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.LogOut16,
      [IconSize.Medium]: Assets.LogOut24
    }
  },
  [IconType.Loss]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Loss16,
      [IconSize.Medium]: Assets.Loss24
    }
  },
  [IconType.Mail]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Mail16,
      [IconSize.Medium]: Assets.Mail24
    }
  },
  [IconType.MasterCard]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MasterCard16,
      [IconSize.Medium]: Assets.MasterCard24
    }
  },
  [IconType.Maximine]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Maximine16,
      [IconSize.Medium]: Assets.Maximine24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Maximine16Solid,
      [IconSize.Medium]: Assets.Maximine24Solid
    }
  },
  [IconType.MelioMe]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MelioMe16,
      [IconSize.Medium]: Assets.MelioMe24
    }
  },
  [IconType.Metadata]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Metadata16,
      [IconSize.Medium]: Assets.Metadata24
    }
  },
  [IconType.Mic]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Mic16,
      [IconSize.Medium]: Assets.Mic24
    }
  },
  [IconType.Minus]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Minus16,
      [IconSize.Medium]: Assets.Minus24
    }
  },
  [IconType.Mobile]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Mobile16,
      [IconSize.Medium]: Assets.Mobile24
    }
  },
  [IconType.MoneyIn]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MoneyIn16,
      [IconSize.Medium]: Assets.MoneyIn24
    }
  },
  [IconType.MoneyOut]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MoneyOut16,
      [IconSize.Medium]: Assets.MoneyOut24
    }
  },
  [IconType.MoreHorizontal]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MoreHorizontal16,
      [IconSize.Medium]: Assets.MoreHorizontal24
    }
  },
  [IconType.MoreVertical]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MoreVertical16,
      [IconSize.Medium]: Assets.MoreVertical24
    }
  },
  [IconType.MsnApproved]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MsnApproved16,
      [IconSize.Medium]: Assets.MsnApproved24
    }
  },
  [IconType.MsnEnrolled]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MsnEnrolled16,
      [IconSize.Medium]: Assets.MsnEnrolled24
    }
  },
  [IconType.MyTasks]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.MyTasks16,
      [IconSize.Medium]: Assets.MyTasks24
    }
  },
  [IconType.OpenCorporate]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.OpenCorporate16,
      [IconSize.Medium]: Assets.OpenCorporate24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.OpenCorporate16Solid,
      [IconSize.Medium]: Assets.OpenCorporate24Solid
    }
  },
  [IconType.OrgEmailVerified]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.OrgEmailVerified16,
      [IconSize.Medium]: Assets.OrgEmailVerified24
    }
  },
  [IconType.OrgOwesMoney]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.OrgOwesMoney16,
      [IconSize.Medium]: Assets.OrgOwesMoney24
    }
  },
  [IconType.OrgStatus]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.OrgStatus16,
      [IconSize.Medium]: Assets.OrgStatus24
    }
  },
  [IconType.OrgTasks]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.OrgTasks16,
      [IconSize.Medium]: Assets.OrgTasks24
    }
  },
  [IconType.PaperClip]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PaperClip16,
      [IconSize.Medium]: Assets.PaperClip24
    }
  },
  [IconType.PartnerStatus]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PartnerStatus16,
      [IconSize.Medium]: Assets.PartnerStatus24
    }
  },
  [IconType.Pause]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Pause16,
      [IconSize.Medium]: Assets.Pause24
    }
  },
  [IconType.Payee]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Payee16,
      [IconSize.Medium]: Assets.Payee24
    }
  },
  [IconType.PaymentExpedited]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PaymentExpedited16,
      [IconSize.Medium]: Assets.PaymentExpedited24
    }
  },
  [IconType.PaymentLimitation]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PaymentLimitation16,
      [IconSize.Medium]: Assets.PaymentLimitation24
    }
  },
  [IconType.PaymentLocator]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PaymentLocator16,
      [IconSize.Medium]: Assets.PaymentLocator24
    }
  },
  [IconType.Payor]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Payor16,
      [IconSize.Medium]: Assets.Payor24
    }
  },
  [IconType.PayorOriginGuest]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PayorOriginGuest16,
      [IconSize.Medium]: Assets.PayorOriginGuest24
    }
  },
  [IconType.Paypal]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Paypal16,
      [IconSize.Medium]: Assets.Paypal24
    }
  },
  [IconType.PaypalBalance]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PaypalBalance16,
      [IconSize.Medium]: Assets.PaypalBalance24
    }
  },
  [IconType.Payroll]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Payroll16,
      [IconSize.Medium]: Assets.Payroll24
    }
  },
  [IconType.Pending]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Pending16,
      [IconSize.Medium]: Assets.Pending24
    }
  },
  [IconType.Phone]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Phone16,
      [IconSize.Medium]: Assets.Phone24
    }
  },
  [IconType.PinEmpty]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PinEmpty16,
      [IconSize.Medium]: Assets.PinEmpty24
    }
  },
  [IconType.PinFilled]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.PinFilled16,
      [IconSize.Medium]: Assets.PinFilled24
    }
  },
  [IconType.Plaid]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Plaid16,
      [IconSize.Medium]: Assets.Plaid24
    }
  },
  [IconType.Plus]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Plus16,
      [IconSize.Medium]: Assets.Plus24
    }
  },
  [IconType.ProhibitedIndustry]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ProhibitedIndustry16,
      [IconSize.Medium]: Assets.ProhibitedIndustry24
    }
  },
  [IconType.Projects]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Projects16,
      [IconSize.Medium]: Assets.Projects24
    }
  },
  [IconType.Quickbooks]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Quickbooks16,
      [IconSize.Medium]: Assets.Quickbooks24
    }
  },
  [IconType.QuickView]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.QuickView16,
      [IconSize.Medium]: Assets.QuickView24
    }
  },
  [IconType.RecoCustomerFunds]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoCustomerFunds16,
      [IconSize.Medium]: Assets.RecoCustomerFunds24
    }
  },
  [IconType.RecoDashboard]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoDashboard16,
      [IconSize.Medium]: Assets.RecoDashboard24
    }
  },
  [IconType.RecoDDAClosingReportNoGaps]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoDDAClosingReportNoGaps16,
      [IconSize.Medium]: Assets.RecoDDAClosingReportNoGaps24
    }
  },
  [IconType.RecoDDAClosingReportWithGaps]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoDDAClosingReportWithGaps16,
      [IconSize.Medium]: Assets.RecoDDAClosingReportWithGaps24
    }
  },
  [IconType.RecoGaps]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoGaps16,
      [IconSize.Medium]: Assets.RecoGaps24
    }
  },
  [IconType.RecoJPMReport]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoJPMReport16,
      [IconSize.Medium]: Assets.RecoJPMReport24
    }
  },
  [IconType.RecoRevenueAccounts]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoRevenueAccounts16,
      [IconSize.Medium]: Assets.RecoRevenueAccounts24
    }
  },
  [IconType.RecoTransferSearch]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoTransferSearch16,
      [IconSize.Medium]: Assets.RecoTransferSearch24
    }
  },
  [IconType.RecoVendorBalance]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecoVendorBalance16,
      [IconSize.Medium]: Assets.RecoVendorBalance24
    }
  },
  [IconType.RecurringPayment]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RecurringPayment16,
      [IconSize.Medium]: Assets.RecurringPayment24
    }
  },
  [IconType.Redash]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Redash16,
      [IconSize.Medium]: Assets.Redash24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Redash16Solid,
      [IconSize.Medium]: Assets.Redash24Solid
    }
  },
  [IconType.Refresh]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Refresh16,
      [IconSize.Medium]: Assets.Refresh24
    }
  },
  [IconType.Refund]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Refund16,
      [IconSize.Medium]: Assets.Refund24
    }
  },
  [IconType.Remove]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Remove16,
      [IconSize.Medium]: Assets.Remove24
    }
  },
  [IconType.RiskStatus]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.RiskStatus16,
      [IconSize.Medium]: Assets.RiskStatus24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.RiskStatus16Solid,
      [IconSize.Medium]: Assets.RiskStatus24Solid
    }
  },
  [IconType.Rpps]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Rpps16,
      [IconSize.Medium]: Assets.Rpps24
    }
  },
  [IconType.Rtp]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Rtp16,
      [IconSize.Medium]: Assets.Rtp24
    }
  },
  [IconType.Sanctions]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Sanctions16,
      [IconSize.Medium]: Assets.Sanctions24
    }
  },
  [IconType.Save]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Save16,
      [IconSize.Medium]: Assets.Save24
    }
  },
  [IconType.SBB]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SBB16,
      [IconSize.Medium]: Assets.SBB24
    }
  },
  [IconType.SBC]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SBC16,
      [IconSize.Medium]: Assets.SBC24
    }
  },
  [IconType.ScanFailed]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ScanFailed16,
      [IconSize.Medium]: Assets.ScanFailed24
    }
  },
  [IconType.Search]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Search16,
      [IconSize.Medium]: Assets.Search24
    }
  },
  [IconType.SearchError]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SearchError16,
      [IconSize.Medium]: Assets.SearchError24
    }
  },
  [IconType.SelfProclaimed]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SelfProclaimed16,
      [IconSize.Medium]: Assets.SelfProclaimed24
    }
  },
  [IconType.Send]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Send16,
      [IconSize.Medium]: Assets.Send24
    }
  },
  [IconType.Setting]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Setting16,
      [IconSize.Medium]: Assets.Setting24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Setting16Solid,
      [IconSize.Medium]: Assets.Setting24Solid
    }
  },
  [IconType.ShieldCheck]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ShieldCheck16,
      [IconSize.Medium]: Assets.ShieldCheck24
    }
  },
  [IconType.ShiftManager]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ShiftManager16,
      [IconSize.Medium]: Assets.ShiftManager24
    }
  },
  [IconType.Shopify]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Shopify16,
      [IconSize.Medium]: Assets.Shopify24
    }
  },
  [IconType.ShopifyWallet]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ShopifyWallet16,
      [IconSize.Medium]: Assets.ShopifyWallet24
    }
  },
  [IconType.Show]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Show16,
      [IconSize.Medium]: Assets.Show24
    }
  },
  [IconType.Slack]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Slack16,
      [IconSize.Medium]: Assets.Slack24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Slack16Solid,
      [IconSize.Medium]: Assets.Slack24Solid
    }
  },
  [IconType.SortDefault]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SortDefault16,
      [IconSize.Medium]: Assets.SortDefault24
    }
  },
  [IconType.SortDown]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SortDown16,
      [IconSize.Medium]: Assets.SortDown24
    }
  },
  [IconType.SortUp]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SortUp16,
      [IconSize.Medium]: Assets.SortUp24
    }
  },
  [IconType.StrategyBuilder]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.StrategyBuilder16,
      [IconSize.Medium]: Assets.StrategyBuilder24
    }
  },
  [IconType.StrategyRules]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.StrategyRules16,
      [IconSize.Medium]: Assets.StrategyRules24
    }
  },
  [IconType.Subscription]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Subscription16,
      [IconSize.Medium]: Assets.Subscription24
    }
  },
  [IconType.SUVC]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SUVC16,
      [IconSize.Medium]: Assets.SUVC24
    }
  },
  [IconType.SVB]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.SVB16,
      [IconSize.Medium]: Assets.SVB24
    }
  },
  [IconType.TaxForm]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.TaxForm16,
      [IconSize.Medium]: Assets.TaxForm24
    }
  },
  [IconType.TestPayment]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.TestPayment16,
      [IconSize.Medium]: Assets.TestPayment24
    }
  },
  [IconType.ThemeEditor]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ThemeEditor16,
      [IconSize.Medium]: Assets.ThemeEditor24
    }
  },
  [IconType.ThumbDown]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ThumbDown16,
      [IconSize.Medium]: Assets.ThumbDown24
    }
  },
  [IconType.ThumbUp]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ThumbUp16,
      [IconSize.Medium]: Assets.ThumbUp24
    }
  },
  [IconType.TierDiscount]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.TierDiscount16,
      [IconSize.Medium]: Assets.TierDiscount24
    }
  },
  [IconType.Trulioo]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Trulioo16,
      [IconSize.Medium]: Assets.Trulioo24
    }
  },
  [IconType.UncollectedFunds]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.UncollectedFunds16,
      [IconSize.Medium]: Assets.UncollectedFunds24
    }
  },
  [IconType.Unlock]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Unlock16,
      [IconSize.Medium]: Assets.Unlock24
    }
  },
  [IconType.UnMatch]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.UnMatch16,
      [IconSize.Medium]: Assets.UnMatch24
    }
  },
  [IconType.User]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.User16,
      [IconSize.Medium]: Assets.User24
    }
  },
  [IconType.UserDeleted]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.UserDeleted16,
      [IconSize.Medium]: Assets.UserDeleted24
    }
  },
  [IconType.UserRemoved]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.UserRemoved16,
      [IconSize.Medium]: Assets.UserRemoved24
    }
  },
  [IconType.VendorApproved]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.VendorApproved16,
      [IconSize.Medium]: Assets.VendorApproved24
    }
  },
  [IconType.Vendors]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Vendors16,
      [IconSize.Medium]: Assets.Vendors24
    }
  },
  [IconType.VirtualCard]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.VirtualCard16,
      [IconSize.Medium]: Assets.VirtualCard24
    }
  },
  [IconType.Visa]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Visa16,
      [IconSize.Medium]: Assets.Visa24
    }
  },
  [IconType.Warning]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Warning16,
      [IconSize.Medium]: Assets.Warning24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Warning16Solid,
      [IconSize.Medium]: Assets.Warning24Solid
    }
  },
  [IconType.Web]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Web16,
      [IconSize.Medium]: Assets.Web24
    }
  },
  [IconType.WellsFargo]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.WellsFargo16,
      [IconSize.Medium]: Assets.WellsFargo24
    }
  },
  [IconType.Wire]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Wire16,
      [IconSize.Medium]: Assets.Wire24
    }
  },
  [IconType.Xero]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Xero16,
      [IconSize.Medium]: Assets.Xero24
    }
  },
  [IconType.Zendesk]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Zendesk16,
      [IconSize.Medium]: Assets.Zendesk24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Zendesk16Solid,
      [IconSize.Medium]: Assets.Zendesk24Solid
    }
  },
  [IconType.ZendeskActionRequired]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ZendeskActionRequired16,
      [IconSize.Medium]: Assets.ZendeskActionRequired24
    }
  },
  [IconType.ZendeskOnHold]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ZendeskOnHold16,
      [IconSize.Medium]: Assets.ZendeskOnHold24
    }
  },
  [IconType.ZendeskResponded]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.ZendeskResponded16,
      [IconSize.Medium]: Assets.ZendeskResponded24
    }
  },
  [IconType.Zoominfo]: {
    [IconVariant.Outline]: {
      [IconSize.Small]: Assets.Zoominfo16,
      [IconSize.Medium]: Assets.Zoominfo24
    },
    [IconVariant.Solid]: {
      [IconSize.Small]: Assets.Zoominfo16Solid,
      [IconSize.Medium]: Assets.Zoominfo24Solid
    }
  }
  };
  